import { IIconBase } from '..'

const simulationIcon = ({
  color = '#333',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      version='1.0'
      width={width}
      height={height}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M2346 5020 c-67 -21 -106 -85 -106 -174 0 -53 -1 -55 -32 -61 -18 -4
-72 -25 -120 -48 l-88 -40 -49 46 c-56 52 -100 65 -158 46 -46 -15 -294 -254
-324 -311 -31 -60 -20 -124 29 -180 14 -17 -15 -18 -605 -18 -710 0 -692 2
-773 -79 -87 -87 -80 40 -80 -1551 0 -1591 -7 -1464 80 -1551 82 -82 42 -79
952 -79 l798 0 0 -235 0 -235 -202 0 c-112 0 -221 -5 -242 -10 -63 -14 -118
-59 -148 -119 -26 -50 -28 -64 -28 -173 0 -105 2 -120 20 -138 20 -20 33 -20
1290 -20 1257 0 1270 0 1290 20 18 18 20 33 20 138 0 109 -2 123 -27 173 -31
60 -86 105 -149 119 -21 5 -130 10 -241 10 l-203 0 0 235 0 235 798 0 c910 0
870 -3 952 79 87 87 80 -40 80 1551 0 1591 7 1464 -80 1551 -81 81 -63 79
-773 79 -590 0 -619 1 -605 18 54 61 61 128 19 193 -46 72 -270 284 -314 299
-58 18 -102 5 -158 -47 l-49 -46 -88 40 c-48 23 -101 44 -118 47 -31 7 -32 8
-36 76 -4 74 -19 105 -72 144 -25 19 -43 21 -229 23 -111 1 -215 -2 -231 -7z
m402 -122 c7 -7 12 -44 12 -94 0 -56 4 -85 13 -93 8 -6 49 -22 93 -37 43 -14
120 -46 171 -71 l92 -46 39 26 c21 15 53 43 72 62 19 19 38 35 44 35 15 0 266
-253 266 -269 0 -8 -27 -42 -60 -77 -33 -34 -60 -67 -60 -72 0 -5 20 -49 45
-98 25 -49 55 -120 67 -159 33 -114 35 -115 131 -115 51 0 88 -5 95 -12 8 -8
12 -64 12 -188 0 -124 -4 -180 -12 -188 -7 -7 -42 -12 -88 -12 -46 0 -83 -5
-92 -12 -9 -7 -30 -55 -47 -106 -17 -51 -49 -129 -72 -172 -38 -75 -39 -80
-25 -107 8 -15 35 -48 60 -73 25 -24 46 -49 46 -54 0 -17 -253 -266 -270 -266
-9 0 -40 25 -70 55 -37 37 -62 55 -79 55 -14 0 -59 -18 -101 -39 -41 -21 -113
-51 -160 -65 -47 -15 -91 -34 -97 -43 -8 -10 -13 -48 -13 -93 0 -46 -5 -81
-12 -88 -17 -17 -359 -17 -376 0 -7 7 -12 42 -12 88 0 45 -5 83 -12 93 -7 9
-51 28 -98 43 -47 14 -119 44 -160 65 -42 21 -87 39 -101 39 -17 0 -42 -18
-79 -55 -30 -30 -61 -55 -70 -55 -18 0 -270 249 -270 268 0 7 27 42 60 77 33
35 60 68 60 71 0 4 -20 46 -44 93 -24 47 -56 124 -70 171 -15 47 -34 91 -43
98 -10 7 -48 12 -93 12 -46 0 -81 5 -88 12 -17 17 -17 359 0 376 7 7 44 12 94
12 53 0 85 4 92 13 5 6 24 54 41 106 17 51 49 127 71 169 22 41 40 79 40 85 0
5 -27 37 -60 71 -33 35 -60 69 -60 77 0 16 251 269 266 269 6 0 30 -21 54 -46
25 -25 58 -52 74 -61 28 -15 32 -14 120 30 50 26 127 58 170 72 44 14 85 30
93 36 9 8 13 37 13 93 0 50 5 87 12 94 17 17 359 17 376 0z m-1248 -747 c0 -5
-11 -37 -24 -72 l-24 -64 -557 -5 c-536 -5 -557 -6 -571 -24 -12 -17 -14 -216
-14 -1338 0 -1305 0 -1318 20 -1338 20 -20 33 -20 2228 -20 l2208 0 22 20 22
21 0 1318 0 1318 -21 19 c-20 18 -48 19 -571 24 l-549 5 -29 73 -28 72 628 -2
c618 -3 629 -3 657 -24 15 -11 36 -36 46 -55 16 -32 17 -117 15 -1441 -3
-1405 -3 -1407 -24 -1435 -11 -15 -36 -36 -55 -45 -32 -17 -163 -18 -2319 -18
-2156 0 -2287 1 -2319 18 -19 9 -44 30 -55 45 l-21 28 0 1419 0 1419 21 28
c48 65 25 63 702 63 345 0 612 -4 612 -9z m-280 -458 c0 -176 2 -201 20 -238
26 -54 70 -79 149 -85 l63 -5 28 -75 c15 -41 37 -94 49 -118 l22 -44 -45 -48
c-78 -83 -73 -159 14 -245 l50 -49 -185 -186 -185 -186 0 -205 0 -204 -50 -28
c-55 -30 -105 -97 -116 -154 -26 -137 84 -267 225 -266 235 3 308 316 99 424
l-38 19 0 183 0 182 167 167 167 167 56 -54 c89 -84 162 -87 247 -11 48 44 49
44 78 28 17 -9 68 -30 115 -48 l85 -32 6 -64 c10 -119 65 -168 188 -168 l71 0
0 -175 0 -175 -32 -13 c-18 -8 -50 -32 -71 -53 -80 -82 -84 -207 -10 -293 110
-130 297 -108 375 44 26 50 28 136 4 186 -22 47 -73 98 -113 116 l-33 13 0
175 0 175 71 0 c123 0 178 49 188 168 l6 64 45 15 c25 8 77 30 117 48 l71 33
29 -30 c15 -16 45 -38 65 -49 72 -37 135 -20 208 55 l44 46 168 -167 168 -168
0 -182 0 -183 -37 -19 c-166 -85 -165 -317 1 -403 94 -48 222 -15 283 75 76
113 42 259 -77 324 l-50 28 0 204 0 205 -184 185 -185 186 54 57 c83 89 86
156 9 238 l-44 47 31 69 c18 38 39 92 49 119 l17 50 64 5 c79 6 123 31 149 85
18 37 20 62 20 238 l0 197 395 0 395 0 0 -1240 0 -1240 -2130 0 -2130 0 0
1240 0 1240 395 0 395 0 0 -197z m113 -1843 c71 -79 -4 -198 -107 -169 -40 11
-76 57 -76 97 0 37 29 83 63 98 44 19 87 10 120 -26z m1272 24 c68 -32 80
-117 24 -170 -81 -77 -212 18 -164 120 15 32 62 65 93 66 8 0 29 -7 47 -16z
m1300 2 c36 -15 65 -59 65 -98 0 -40 -36 -86 -76 -97 -98 -27 -175 84 -113
163 36 45 70 54 124 32z m-1689 -894 c60 -103 170 -186 278 -209 75 -15 156
-4 230 34 57 29 151 120 181 176 l20 37 102 0 103 0 0 -235 0 -235 -570 0
-570 0 0 235 0 235 103 0 102 0 21 -38z m555 19 c-32 -58 -133 -113 -211 -113
-78 0 -179 55 -211 113 -9 18 -2 19 211 19 213 0 220 -1 211 -19z m914 -585
c46 -20 65 -61 65 -141 l0 -65 -1190 0 -1190 0 0 65 c0 79 19 121 63 140 48
21 2202 22 2252 1z'
        />
        <path
          d='M2360 4479 c-162 -42 -321 -142 -426 -268 -67 -80 -137 -218 -165
-326 -27 -102 -30 -278 -5 -378 73 -304 308 -539 612 -613 92 -23 276 -23 368
0 204 49 377 169 490 340 99 149 139 282 138 461 -1 371 -255 694 -616 785
-108 27 -291 27 -396 -1z m378 -119 c247 -69 433 -259 498 -510 22 -84 22
-233 0 -325 -47 -196 -188 -371 -371 -460 -103 -51 -183 -69 -305 -69 -122 0
-202 18 -305 69 -181 88 -318 257 -371 455 -22 84 -22 242 0 333 58 244 258
445 506 511 85 23 260 20 348 -4z'
        />
        <path
          d='M2248 4193 c-8 -10 -76 -126 -152 -257 -101 -178 -135 -245 -130
-260 13 -41 266 -472 290 -493 25 -23 29 -23 304 -23 275 0 279 0 303 23 25
22 278 452 291 493 5 15 -27 79 -125 250 -72 126 -140 241 -151 257 l-19 27
-298 0 c-271 0 -299 -2 -313 -17z m627 -240 c43 -76 88 -153 98 -170 l19 -33
-200 0 -199 0 -93 163 c-51 89 -95 165 -97 170 -2 4 85 7 194 7 l199 0 79
-137z m-481 -96 l97 -169 -98 -169 c-54 -93 -100 -169 -103 -169 -3 1 -48 77
-101 169 l-96 169 45 79 c103 180 154 264 156 261 2 -1 47 -79 100 -171z m596
-231 c0 -2 -44 -79 -98 -172 l-98 -169 -197 -3 c-108 -1 -197 1 -197 4 0 4 44
82 98 175 l97 169 198 0 c108 0 197 -2 197 -4z'
        />
      </g>
    </svg>
  )
}

export default simulationIcon
